export const Ready = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='8' cy='8' r='7' fill='#FBBF24' stroke='#FBBF24' strokeWidth='2' />
    <path
      d='M5 8L7 10L11 6'
      stroke='white'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const InProgress = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='8' cy='8' r='8' fill='#10B981' />
    <path
      d='M11.2929 8.70711C11.6834 8.31658 11.6834 7.68342 11.2929 7.29289L7.70711 3.70711C7.07714 3.07714 6 3.52331 6 4.41421L6 11.5858C6 12.4767 7.07714 12.9229 7.70711 12.2929L11.2929 8.70711Z'
      fill='white'
    />
  </svg>
);

export const Awaiting = () => (
  <svg width='13' height='13' viewBox='0 0 13 13' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5.36808 2.09987L11.0358 7.74279C9.353 9.41473 6.87995 12.0592 3.9521 9.14438C1.0243 6.22937 3.68532 3.77181 5.36808 2.09987Z'
      fill='#EF4444'
      stroke='#EF4444'
      strokeWidth='2'
      strokeLinecap='round'
      //l='round'
    />
    <path
      d='M1 12L4.67188 8.44971'
      stroke='#EF4444'
      strokeWidth='2'
      strokeLinecap='round'
      //l='round'
    />
    <path
      d='M9 1L7 3'
      stroke='#EF4444'
      strokeWidth='2'
      strokeLinecap='round'
      //l='round'
    />
    <path
      d='M12 4L10 6'
      stroke='#EF4444'
      strokeWidth='2'
      strokeLinecap='round'
      //l='round'
    />
  </svg>
);
